import { MESSAGE_STATUSES } from "../../../../packages/constants";
import {
  ErrorIcon,
  ReadIcon,
  ReceivedIcon,
  SentIcon,
} from "../../../../packages/icons";
import styles from "./chat-message.module.scss";

type Props = {
  status: MESSAGE_STATUSES;
};

const StatusIconMap = {
  [MESSAGE_STATUSES.SEND]: <SentIcon />,
  [MESSAGE_STATUSES.RECEIVED]: <ReceivedIcon />,
  [MESSAGE_STATUSES.READ]: <ReadIcon />,
  [MESSAGE_STATUSES.ERROR]: <ErrorIcon />,
};

const getTestId = (status: Props["status"]) =>
  `chat-message-status-${status.toLowerCase()}`;

export const ChatMessageStatus = ({ status }: Readonly<Props>) => (
  <span data-test-id={getTestId(status)} className={styles.status}>
    {StatusIconMap[status]}
  </span>
);
